import { AfterViewInit, Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Answer } from 'src/app/shared/interfaces/answer';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs';
import { FieldValueItemComponent } from 'src/app/components/field-value-item/field-value-item.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-print-answer',
  imports: [TranslateModule, FieldValueItemComponent, DatePipe],
  standalone: true,
  templateUrl: './print-answer.component.html',
  styleUrl: './print-answer.component.scss',
})
export class PrintAnswerComponent implements AfterViewInit, OnInit {
  answer!: Answer;

  constructor(
    private $http: HttpClient,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.route.paramMap.pipe(first()).subscribe((params) => {
      if (params.get('id')) {
        this.$http.get<Answer>(`answers/${params.get('id')}`).subscribe((res)=> {
          this.answer = res
        });
      }
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      window.print();
    }, 1000);
  }
}
